/*
 * @Author: your name
 * @Date: 2020-07-23 19:58:49
 * @LastEditTime: 2020-09-22 15:36:18
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: /x-product-h5-workspace/packages/xdap-h5/src/api/index.js
 */
import AccountApi from './account/index'
import WorkbenchApi from './workbench/index'
import AppPageApi from './app-page/index'
import ComponentApi from './component/index'
import ProfileApi from './personal-center/index'
import FormApi from './form/index'
import MessageCenterApi from './message-center/index'
import TodoCenterApi from './todo-center/index'
import PublicFormApi from './public-form/index'
import MessageRemindApi from './message-remind/index'

const apis = {
}

const allApis = [
  { ...AccountApi },
  { ...AppPageApi },
  { ...WorkbenchApi },
  { ...ComponentApi },
  { ...ProfileApi },
  { ...FormApi },
  { ...MessageCenterApi },
  { ...TodoCenterApi },
  { ...PublicFormApi },
  { ...MessageRemindApi }
]

const loadApis = () => {
  allApis.forEach((api) => {
    apis[api.module] = { ...api }
  })
}

export default apis

export { loadApis }
